import * as React from "react";
import { DataGrid } from "@mui/x-data-grid/DataGrid";
import { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import styles from "./productlist.module.css";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddProductButton from "../AddProductButton";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast, Bounce } from "react-toastify";
import AddProductModal from "../AddProductModal";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import {
  addProduct,
  getProducts,
  getCategories,
  getMetadataProducts,
  updateProduct,
  disableProduct,
} from "../../apis/sellerProduct";
import { dataURLtoFile } from "../../utils/formData";
import ImageWithFallback from "../ImageWithFallback";

export default function ProductList() {
  const [initialRows, setInitialRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [product, setProduct] = useState();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [newItem, setNewItem] = useState({
    id: "",
    productImages: [],
    productName: "",
    brand: "",
    categories1: "",
    categories2: "",
    categories3: [],
    categories4: [],
    quantity: "",
    description: "",
    price: "",
    productCode: "",
  });
  const [error, setError] = useState({
    productName: false,
    brand: false,
    categories3: false,
    quantity: false,
    description: false,
    price: false,
  });
  const handlePaginationChange = async (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
    // setInitialRows([]);
    // console.log("Current Page:", newPaginationModel.page);
    // console.log("Current Page Size:", newPaginationModel.pageSize);
    const data = {
      sellerId: cookies["user_info"].sellerId,
      perPage: newPaginationModel.pageSize,
      page: newPaginationModel.page,
    };
    // const productDataList = [];
    getProducts(data, cookies["access_token"]).then((result) => {
      if (result.status === 200) {
        setProduct(result.data.data);
        // console.log(result.data.data);
        // const productCategories3 = [];
        // let productCategories4 = "";
        // result.data.data.forEach((item) => {
        //   item.categories.forEach((category) => {
        //     if (category.level === 3) {
        //       productCategories3.push(category);
        //     }
        //   });
        //   const productData = {
        //     id: item.id,
        //     productImages: item.images,
        //     productName: item.name,
        //     brand: item.brand,
        //     categories1: item.categories[0].name,
        //     categories2: item.categories[1].name,
        //     categories3: productCategories3,
        //     categories4: item.cusCategories
        //       ? item.cusCategories.split(",")
        //       : [],
        //     quantity: item.stockQuantity,
        //     description: item.description,
        //     createDate: item.createDatetime,
        //     updateDate: item.updateDatetime,
        //     price: item.price,
        //   };
        //   productDataList.push(productData);
        // });
        // console.log(result.data.data);
        // console.log(result.data.data[0].productMetadatas[0].productCode);
        // setInitialRows(productDataList);
      } else {
        console.log("Error: ", result);
      }
    });
  };
  useEffect(() => {
    setRows(initialRows);
  }, [initialRows]);
  useEffect(() => {
    if (product) {
      // Step 1: Collect all distinct product codes
      const allProductCodes = new Set();
      product.forEach((item) => {
        item.productMetadatas.forEach((metadata) => {
          allProductCodes.add(metadata.productCode);
        });
      });

      // Step 2: Create an object based on distinct product codes
      const combinedProductMetadatasByCode = Array.from(allProductCodes).reduce(
        (acc, productCode) => {
          product.forEach((item) => {
            let productCategories3 = [];
            item.categories.forEach((category) => {
              if (category.level === 3) {
                productCategories3.push(category);
              }
            });
            const matchingMetadatas = item.productMetadatas.filter(
              (m) => m.productCode === productCode
            );
            if (matchingMetadatas.length > 0) {
              matchingMetadatas.forEach((metadata) => {
                if (acc[productCode]) {
                  acc[productCode].productMetadata.push(metadata);
                } else {
                  acc[productCode] = {
                    id: productCode,
                    categories: item.categories,
                    cusCategories: item.cusCategories,
                    productName: item.name,
                    brand: item.brand,
                    price: metadata.price,
                    quantity: metadata.stockQuantity,
                    productImages: item.images,
                    categories1: item.categories[0].name,
                    categories2: item.categories[1].name,
                    categories3: productCategories3,
                    categories4: item.cusCategories
                      ? item.cusCategories.split(",")
                      : [],
                    description: item.description,
                    createDate: item.createDatetime,
                    updateDate: item.updateDatetime,
                    productMetadata: [metadata],
                  };
                }
              });
            }
          });
          return acc;
        },
        {}
      );

      console.log("data: ", Object.values(combinedProductMetadatasByCode));
      setInitialRows(Object.values(combinedProductMetadatasByCode));
      setProductMetadatas(combinedProductMetadatasByCode);
    }
  }, [product]);

  const { t } = useTranslation();
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);
  const [metadataInput, setMetadataInput] = useState([]);
  const [productMetadatas, setProductMetadatas] = useState([]);
  const [distinctProductCodes, setDistinctProductCodes] = useState([]);
  const [categories1Options, setCategories1Options] = useState([]);
  const [categories2Options, setCategories2Options] = useState([]);
  const [categories3Options, setCategories3Options] = useState(["Option 1"]);
  const [categories4Options, setCategories4Options] = useState([]);
  useEffect(() => {
    handlePaginationChange(paginationModel);
    getCategories(1, cookies["access_token"]).then((result) => {
      if (result.status === 200) {
        setCategories1Options(result.data.data);
      } else {
        console.log("Error: ", result);
      }
    });
    getCategories(2, cookies["access_token"]).then((result) => {
      if (result.status === 200) {
        setCategories2Options(result.data.data);
      } else {
        console.log("Error: ", result);
      }
    });
    getCategories(3, cookies["access_token"]).then((result) => {
      if (result.status === 200) {
        // setCategories3Options(result.data.data);
      } else {
        console.log("Error: ", result);
      }
    });
    console.log(product);
  }, []);
  useEffect(() => {
    // Initialize newItem with dynamic fields from metadataInput
    console.log(metadataInput);
    const newFields = metadataInput.reduce((acc, metadata) => {
      acc[metadata.id] = ""; // Add a new field to newItem with metadata.id as the key
      return acc;
    }, {});
    const newErrorFields = metadataInput.reduce((acc, metadata) => {
      acc[metadata.id] = false; // Add a new field to newItem with metadata.id as the key
      return acc;
    }, {});
    if (!edit) {
      setNewItem((prevItem) => ({
        ...prevItem,
        ...newFields,
      }));
    }
    setError((prevError) => ({
      ...prevError,
      ...newErrorFields,
    }));
  }, [metadataInput]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [currentRowID, setCurrentRowID] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = (event) => {
    if (!event || event.target.role !== "dialog") {
      setOpen(false);
    }
    setEdit(false);
    setMetadataInput([]);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewItem((prevItem) => ({ ...prevItem, [name]: value }));
    if (name === "price" || name === "quantity") {
      if (parseFloat(value) <= 0) {
        setError((prevError) => ({ ...prevError, [name]: true }));
        return;
      }
    }
    if (name === "categories2") {
      getMetadataProducts(value, cookies["access_token"]).then((result) => {
        if (result.status === 200) {
          setMetadataInput(result.data.data);
        } else {
          console.log("Error: ", result);
        }
      });
    }
    if (value === "") {
      setError((prevError) => ({ ...prevError, [name]: true }));
    } else {
      setError((prevError) => ({ ...prevError, [name]: false }));
    }
  };
  const handleCategories3Change = (event, value) => {
    setNewItem((prevItem) => ({ ...prevItem, categories3: value }));
    if (value.length === 0) {
      setError((prevError) => ({ ...prevError, categories3: true }));
    } else {
      setError((prevError) => ({ ...prevError, categories3: false }));
    }
  };
  const handleCategories4Change = (event, value) => {
    if (
      typeof event.target.value === "string" &&
      event.target.value.includes(",")
    ) {
      const splitValues = event.target.value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item);
      setNewItem((prevItem) => ({
        ...prevItem,
        categories4: [...prevItem.categories4, ...splitValues],
      }));
      event.target.value = "";
    } else if (event._reactName === "onKeyDown" && event.keyCode === 13) {
      setNewItem((prevItem) => {
        const categories4 = [...prevItem.categories4, event.target.value];
        delete prevItem.categories4;
        return {
          ...prevItem,
          categories4: categories4,
        };
      });
      event.target.value = "";
    } else if (event._reactName === "onClick") {
      setNewItem((prevItem) => ({ ...prevItem, categories4: value }));
    }
  };

  const handleSubmit = () => {
    // Validation for required fields
    console.log(error);
    if (!Object.values(error).every((value) => value === false)) {
      toast.error("Please fill in all required fields.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      return;
    }
    let newProduct = new FormData();
    const allCategories = [
      newItem.categories1,
      newItem.categories2,
      // ...newItem.categories3,
      newItem.categories4.join(", "),
    ];
    newProduct.append("Name", newItem.productName);
    newProduct.append("Description", newItem.description);
    newProduct.append("Price", parseFloat(newItem.price));
    // newProduct.append("StockQuantity", parseInt(newItem.quantity, 10));
    newItem.productImages.forEach((image, index) => {
      const file = dataURLtoFile(image, `image-${index}.png`);
      newProduct.append("Images", file);
    });
    {
      metadataInput.map((metadata) => {
        newProduct.append(
          "MetadataDtos",
          JSON.stringify({
            metadataId: metadata.id,
            value: newItem[metadata.id],
            price: newItem.price,
            StockQuantity: newItem.quantity,
          })
        );
      });
    }
    newProduct.append("Brand", newItem.brand);
    newProduct.append("SellerId", cookies["user_info"].sellerId);
    allCategories.forEach((category) => {
      newProduct.append(`Categories`, category);
    });
    // const result = getUserMeta(cookies["access_token"]);
    // console.log(result);
    // newItem.categories4.forEach((category) => {
    //   const metadata = {
    //     metadataId: ``,
    //     value: category,
    //   };
    //   const metadataString = JSON.stringify(metadata);
    //   newProduct.append("MetadataDtos", metadataString);
    // });
    //debugging
    // for (let pair of newProduct.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }

    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await addProduct(newProduct, cookies["access_token"]);
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return "Submitting...";
          },
          position: "top-center",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        success: {
          render({ data }) {
            handlePaginationChange(paginationModel);
            setNewItem({
              id: "",
              productImages: [],
              productName: "",
              brand: "",
              categories1: "",
              categories2: "",
              categories3: [],
              categories4: [],
              quantity: "",
              description: "",
              price: "",
            });

            handleClose();
            return "Product added successfully!";
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        error: {
          render({ data }) {
            return `An error occurred: ${
              data.response?.data?.message || data.message
            }`;
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
      }
    );
  };
  const handleSave = () => {
    // Validation for required fields
    if (!Object.values(error).every((value) => value === false)) {
      toast.error("Please fill in all required fields.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      return;
    }
    let newProduct = new FormData();
    const allCategories = [
      newItem.categories1,
      newItem.categories2,
      // ...newItem.categories3,
      newItem.categories4.join(", "),
    ];
    newProduct.append("Name", newItem.productName);
    newProduct.append("Description", newItem.description);
    // newProduct.append("Price", newItem.price);
    // newProduct.append("StockQuantity", newItem.quantity);
    newItem.productImages.forEach((image, index) => {
      const file = dataURLtoFile(image, `image-${index}.png`);
      newProduct.append("Images", file);
    });
    newProduct.append(
      "Id",
      productMetadatas[currentRowID].productMetadata[0].productId
    );
    {
      metadataInput.map((metadata) => {
        newProduct.append(
          "MetadataDtos",
          JSON.stringify({
            metadataId: metadata.id,
            value: newItem[metadata.id],
            ProductCode: currentRowID,
            StockQuantity: newItem.quantity,
            price: newItem.price,
          })
        );
      });
    }
    newProduct.append("Brand", newItem.brand);
    newProduct.append("SellerId", cookies["user_info"].sellerId);
    allCategories.forEach((category) => {
      newProduct.append(`Categories`, category);
    });
    // const result = getUserMeta(cookies["access_token"]);
    // console.log(result);
    // newItem.categories4.forEach((category) => {
    //   const metadata = {
    //     metadataId: ``,
    //     value: category,
    //   };
    //   const metadataString = JSON.stringify(metadata);
    //   newProduct.append("MetadataDtos", metadataString);
    // });
    //debugging
    // for (let pair of newProduct.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }

    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await updateProduct(newProduct, cookies["access_token"]);
        try {
          if (result.status === 200) resolve(result);
        } catch (error) {
          console.log("Error: ", error);
          reject(error);
        }
      }),
      {
        pending: {
          render() {
            return "Submitting...";
          },
          position: "top-center",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        success: {
          render({ data }) {
            handlePaginationChange(paginationModel);
            setNewItem({
              id: "",
              productImages: [],
              productName: "",
              brand: "",
              categories1: "",
              categories2: "",
              categories3: [],
              categories4: [],
              quantity: "",
              description: "",
              price: "",
            });

            handleClose();
            return "Product updated successfully!";
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        error: {
          render({ data }) {
            return `An error occurred: ${
              data.response?.data?.message || data.message
            }`;
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
      }
    );
  };
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "productImages",
      headerName: t("product_images"),
      width: 200,
      renderCell: (params) => (
        <ImageList
          sx={{
            width: 175,
            height: "auto",
            objectFit: "cover",
            overflow: "auto",
          }}
          cols={2}
        >
          {params.value.map((image, index) => (
            <ImageListItem key={image.id} style={{ height: 200 }}>
              <Zoom>
                <ImageWithFallback
                  loading="lazy"
                  src={image.imageURL}
                  alt={`Product ${image.id}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Zoom>
            </ImageListItem>
          ))}
        </ImageList>
      ),
    },
    { field: "productName", headerName: t("product_name"), width: 150 },
    { field: "brand", headerName: t("brand"), width: 130 },
    { field: "categories1", headerName: t("categories_lv1"), width: 150 },
    { field: "categories2", headerName: t("categories_lv2"), width: 150 },
    {
      field: "categories3",
      headerName: t("categories_lv3"),
      width: 150,
      renderCell: (params) => params.value.join(", "),
    },
    {
      field: "categories4",
      headerName: t("categories_lv4"),
      width: 150,
      renderCell: (params) => params.value.join(", "),
    },
    {
      field: "quantity",
      headerName: t("quantity"),
      type: "number",
      width: 100,
    },
    { field: "description", headerName: t("description"), width: 200 },
    {
      field: "createDate",
      headerName: t("create_date"),
      type: "string",
      width: 130,
    },
    {
      field: "updateDate",
      headerName: t("update_date"),
      type: "string",
      width: 130,
    },
    { field: "price", headerName: t("price"), type: "number", width: 100 },
    {
      field: "actions",
      headerName: t("actions"),
      width: 100,
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="edit"
            onClick={() => handleEdit(params.row.id)}
            sx={{ color: "var(--orange)" }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            aria-label="delete"
            onClick={() => handleDelete(params.row.id)}
            sx={{ color: "var(--orange)" }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const [searchText, setSearchText] = useState("");
  const handleDelete = (id) => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await disableProduct(id, cookies["access_token"]);
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return "Deleting...";
          },
          position: "top-center",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        success: {
          render({ data }) {
            handlePaginationChange(paginationModel);
            return "Product deleted successfully!";
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        error: {
          render({ data }) {
            return `An error occurred: ${
              data.response?.data?.message || data.message
            }`;
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
      }
    );
  };
  const handleEdit = (id) => {
    // setProductMetadatas(
    //   product.filter((item) => item.id === id)[0].productMetadatas
    // );
    console.log(productMetadatas[id]);
    productMetadatas[id].productMetadata.map((metadata) => {
      setNewItem((prevItem) => ({
        ...prevItem,
        [metadata.metadataId]: metadata.value,
      }));
      console.log(newItem);
    });
    // console.log(product.filter((item) => item.id === id)[0].productMetadatas);
    // console.log(productMetadatas);
    // const productMetadata = distinctProductCodes.map((productCode) =>
    //   productMetadatas.filter((item) => item.productCode === productCode)
    // );
    setCurrentRowID(id);
    setEdit(true);
    setOpen(true);
  };

  // useEffect(() => {
  //   setDistinctProductCodes([
  //     ...new Set(productMetadatas.map((item) => item.productCode)),
  //   ]);
  // }, [productMetadatas]);
  const handleSearchChange = (event, value) => {
    if (value) {
      const filteredRows = initialRows.filter(
        (row) =>
          row.productName &&
          row.productName.toLowerCase().includes(value.toLowerCase())
      );
      setRows(filteredRows.length > 0 ? filteredRows : initialRows);
    } else {
      setRows(initialRows);
    }
    setSearchText(value);
  };

  return (
    <div className={styles.productTable}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className={styles.searchAddBlock}>
        <div className="col-6">
          <Autocomplete
            disablePortal
            id="search-product"
            options={initialRows.map((row) => row.productName)}
            sx={{ width: 300, marginBottom: "10px" }}
            onInputChange={handleSearchChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </div>
        <div className="col-3 d-flex justify-content-center align-content-middle mt-2">
          <AddProductButton handleOpen={handleOpen} />
          <AddProductModal
            edit={edit}
            handleSave={handleSave}
            id={currentRowID}
            open={open}
            setOpen={setOpen}
            setNewItem={setNewItem}
            handleClose={handleClose}
            handleChange={handleChange}
            handleCategories3Change={handleCategories3Change}
            handleCategories4Change={handleCategories4Change}
            handleSubmit={handleSubmit}
            newItem={newItem}
            metadataInput={metadataInput}
            productMetadatas={productMetadatas}
            distinctProductCodes={distinctProductCodes}
            categories1Options={categories1Options}
            categories2Options={categories2Options}
            categories3Options={categories3Options}
            categories4Options={categories4Options}
            error={error}
          />
        </div>
      </div>
      <DataGrid
        sx={{ ".MuiDataGrid-cell": { overflowY: "auto" } }}
        disableRowSelectionOnClick
        disableColumnResize
        rowHeight={150}
        rows={rows}
        columns={columns}
        paginationMode="server"
        pagination
        rowCount={100}
        initialState={{
          pagination: {
            paginationModel: paginationModel,
          },
        }}
        pageSizeOptions={[5, 10]}
        onPaginationModelChange={handlePaginationChange}
      />
    </div>
  );
}
